export default __webpack_public_path__ + "static/media/error.f0c2c48f.svg";